import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterLink} from "@angular/router";
import {NavigationComponent} from "../navigation/navigation.component";

@Component({
    selector: 'app-home',
    imports: [CommonModule, RouterLink, NavigationComponent],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent {

}
